export default function getGuidStatementClassPrices(guid, rideId) {
  const prices = {};
  let classes;
  try {
    const rides = JSON.parse(sessionStorage.getItem(guid));
    if (`${rides?.departure?.id}` === `${rideId}`) {
      classes = rides.departure.availableSeatsClasses;
    } else {
      classes = rides.return.availableSeatsClasses;
    }
    classes.forEach((seatClass) => {
      prices[seatClass.seatClass.id] = seatClass.priceOfSeats.amount;
    });
    return prices;
  } catch {
    return false;
  }
}
